const throttle = (func, delay) => {
  let lastCall = 0;
  return (...args) => {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return func(...args);
  };
};

document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("searchInputDropdown");
  const dropdown = document.getElementById("search-dropdown");
  const submitBtn = document.getElementById("searchsubmitBtn");

  input.addEventListener("input", throttle(() => showDropdownSearch(input, dropdown), 500));
  input.addEventListener("click", () => showDropdownSearch(input, dropdown));
  submitBtn.addEventListener("click", handleSearch);
  document.addEventListener("click", (event) => handleDocumentClick(event, input, dropdown));
});

function showDropdownSearch(input, dropdown) {
  const filter = input.value.trim();

  if (filter.length > 0) {
    fetch(`${window._Torus.BFF_BASE_URL}/faqs?q=${filter}`)
      .then(response => response.json())
      .then(data => {
        const questions = data.questions
        updateDropdownOptions(questions, input, dropdown);
      })
      .catch(error => {
        console.error('Error fetching search results:', error);
      });
  } else {
    updateDropdownOptions([], input, dropdown);
  }
}

function updateDropdownOptions(options, input, dropdown) {
  dropdown.innerHTML = "";

  options.forEach(option => {
    const div = document.createElement("a");
    div.textContent = option.question;
    div.classList.add("dropdown-item");
    div.dataset.id = option.id;
    div.dataset.section = option.section;
    div.href = `${window.location.origin}/faqs/${option.section}/${option.id}`;
    dropdown.appendChild(div);
  });

  dropdown.style.display = dropdown.innerHTML ? "block" : "none";
}

function handleSearch() {
  const input = document.getElementById("searchInputDropdown");
  moveCursorToEnd(input);
}

function moveCursorToEnd(input) {
  input.focus();
  input.setSelectionRange(input.value.length, input.value.length);
}

function handleDocumentClick(event, input, dropdown) {
  if (!input.contains(event.target) && !dropdown.contains(event.target)) {
    dropdown.style.display = "none";
  }
}